/**
 * Centralised route paths. Importing constants from here means renaming a
 * route only requires changing one file, and prevents typos in links.
 *
 * The `*Path` helpers build the parameterised paths so call sites don't
 * inline string templates and we keep encoding consistent.
 */
export const ROUTES = {
  root: '/',
  login: '/login',
  dashboard: '/dashboard',
  lens: '/lens',
  lensDomain: '/lens/:domain',
  lensComplaint: '/lens/:domain/:complaint',
  curate: '/curate',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];

const slugify = (value: string): string =>
  encodeURIComponent(
    value
      .toLowerCase()
      .replace(/[®™©]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, ''),
  );

export const lensDomainPath = (domain: string): string => `/lens/${slugify(domain)}`;

export const lensComplaintPath = (domain: string, complaint: string): string =>
  `/lens/${slugify(domain)}/${slugify(complaint)}`;

export const complaintSlug = (label: string): string => slugify(label);
